import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EmailserviceService } from '../emailservice.service';

@Component({
  selector: 'app-book-demo',
  templateUrl: './book-demo.component.html',
  styleUrls: ['./book-demo.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule]
})
export class BookDemoComponent implements OnInit {
  demoForm: FormGroup;
  isSubmitting: boolean = false;
  statusMessage: string = '';
  statusType: 'success' | 'error' | '' = '';

  roles: string[] = [
    'University / Academic Admin',
    'Corporate HR / L&D',
    'Accreditation Officer',
    'Exam Controller',
    'Student / Candidate',
    'Other'
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private candidateService: EmailserviceService
  ) {
    this.demoForm = this.fb.group({
      fullName: ['', [Validators.required, Validators.minLength(2)]],
      phoneNumber: ['', [Validators.required, Validators.pattern(/^(\+91[\s-]?)?[6-9]\d{9}$/)]],
      workEmail: ['', [Validators.required, Validators.email]],
      company: ['', Validators.required],
      role: ['', Validators.required],
      dateTime: ['', Validators.required]
    });
  }

  ngOnInit(): void { }

  onSubmit(): void {
    if (this.demoForm.valid && !this.isSubmitting) {
      this.isSubmitting = true;
      this.statusMessage = '';

      const formData = {
        type: 'demo',
        recipientEmail: 'rakshita.i@navriti.com',
        subject: `New Demo Request: ${this.demoForm.value.fullName.trim()} (${this.demoForm.value.company.trim()})`,
        fullName: this.demoForm.value.fullName.trim(),
        phoneNumber: this.demoForm.value.phoneNumber.trim(),
        email: this.demoForm.value.workEmail.trim(),
        company: this.demoForm.value.company.trim(),
        role: this.demoForm.value.role,
        dateTime: this.demoForm.value.dateTime,
        htmlTemplate: `
          <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; border: 1px solid #d1faee; border-radius: 12px; padding: 24px; background-color: #ffffff;">
            <div style="background-color: #01AF67; padding: 16px; border-radius: 8px; text-align: center;">
              <h2 style="color: #ffffff; margin: 0;">New Demo Request - Certiplate</h2>
            </div>
            <div style="padding: 20px 0; color: #334155;">
              <p><strong>Full Name:</strong> ${this.demoForm.value.fullName.trim()}</p>
              <p><strong>Work Email:</strong> ${this.demoForm.value.workEmail.trim()}</p>
              <p><strong>Phone Number:</strong> ${this.demoForm.value.phoneNumber.trim()}</p>
              <p><strong>Company:</strong> ${this.demoForm.value.company.trim()}</p>
              <p><strong>Role:</strong> ${this.demoForm.value.role}</p>
              <p><strong>Preferred Date & Time:</strong> ${this.demoForm.value.dateTime}</p>
            </div>
            <div style="border-top: 1px solid #e2e8f0; padding-top: 12px; font-size: 12px; color: #94a3b8; text-align: center;">
              This notification was generated from the Certiplate Book a Demo portal.
            </div>
          </div>
        `
      };

      this.candidateService.sendDemoRequest(formData).subscribe({
        next: () => {
          this.statusMessage = 'Your demo request has been submitted successfully! We will get in touch with you shortly.';
          this.statusType = 'success';
          this.isSubmitting = false;
          this.demoForm.reset();
        },
        error: (err) => {
          console.error('Error submitting demo form', err);
          this.statusMessage = 'Error submitting demo request. Please try again.';
          this.statusType = 'error';
          this.isSubmitting = false;
        }
      });
    } else {
      this.demoForm.markAllAsTouched();
    }
  }

  goBackHome(): void {
    this.router.navigate(['/']);
  }
}
